import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_table, {
      data: _ctx.list,
      style: {"min-height":"500px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "hid",
          label: "用户id"
        }),
        _createVNode(_component_el_table_column, {
          prop: "phone",
          label: "手机号"
        }),
        _createVNode(_component_el_table_column, { label: "注册时间" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(new Date(scope.row.createdAt).toLocaleString("zh-CN", { hour12: false })), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              type: "text",
              size: "small",
              onClick: _withModifiers(($event: any) => (_ctx.onDeleteUser(scope.row.hid)), ["prevent"])
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_pagination, {
      layout: "prev, pager, next",
      "current-page": _ctx.pagination.page,
      "onUpdate:current-page": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination.page) = $event)),
      "page-count": _ctx.pagination.pageCount
    }, null, 8, ["current-page", "page-count"])
  ]))
}